export default "__VITE_ASSET__178012dd__"